<template>
  <div class="page-wrapper">
    <div v-if="!meetingLive">
      <Navbar :image="data.image" :auth="auth" />
    </div>

    <router-view />

    <div v-if="!meetingLive">
      <Footer :auth="auth" />
    </div>



    <!-- Banner Cookie -->
    <div v-if="showCookieBanner" class="cookie-banner">
      <div class="cookie-content">
        <p>
          Utilizziamo i cookie per migliorare la tua esperienza. Continuando la
          navigazione accetti la nostra
          <a href="/privacy" target="_blank">privacy policy</a>.
        </p>
        <button @click="acceptCookies">Accetta</button>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import { useAuth } from "@/stores/auth.js";
import {
  setCookie,
  getCookie,
  deleteCookie,
  areCookiesEnabled
} from "@/services/cookie.js";
import axios from "axios";

export default {
  name: "App",
  inject: ["headingMain"],
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      data: [],
      auth: false,
      meetingLive: false,
      cookieEnabled: false,
      showCookieBanner: false,
      username: "",
    };
  },
  mounted() {
    const path = window.location.pathname;

    if (path.includes("/meeting/live/"))
    {
      this.meetingLive = true;
    }

    const auth = useAuth();
    this.auth = !!auth.token;

    this.getImage();

    this.cookieEnabled = areCookiesEnabled();
    this.username = getCookie("username") || "";

    if (!getCookie("cookie_consent"))
    {
      this.showCookieBanner = true;
    }
  },
  methods: {
    getImage() {
      let domain = window.location.hostname || "neurohub.it";
      domain = domain === "localhost" ? "demo.neurohub.it" : domain;

      axios
        .post(
          "https://superadmin.neurohub.it/api/dinamic-pages",
          {
            website: `https://${domain}/`,
            slug: "login",
          },
          {
            headers: {
              Authorization: "ae0b35b6f4a58fdbc960dc7e7f9ba362",
              "Content-Type": "application/json",
              sourcehosting: `https://${domain}/`,
            },
          }
        )
        .then((response) => {
          this.data = response.data.content[0];
        })
        .catch((error) => {
          console.log("Errore response", error);
        });
    },
    saveUsername() {
      setCookie("username", this.username, 30);
    },
    clearUsername() {
      deleteCookie("username");
      this.username = "";
    },
    getCookie(name) {
      return getCookie(name);
    },
    acceptCookies() {
      setCookie("cookie_consent", "accepted", 365);
      this.showCookieBanner = false;
    },
  },
};
</script>

<style scoped>
.cookie-test {
  padding: 20px;
  border-top: 1px solid #ccc;
  margin-top: 2rem;
}

.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #222;
  color: #fff;
  padding: 16px;
  z-index: 1000;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
}

.cookie-content {
  max-width: 900px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  font-size: 14px;
}

.cookie-content p {
  margin: 0;
  flex: 1;
  color: #fff;
}

.cookie-content a {
  color: #4fc3f7;
  text-decoration: underline;
}

.cookie-content button {
  background-color: #4fc3f7;
  color: #fff;
  border: none;
  padding: 8px 16px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.cookie-content button:hover {
  background-color: #0288d1;
}
</style>
